import { createStore } from "vuex";
const baseurl = process.env.NODE_ENV != 'production' ? 'https://portret.ai/api' : 'https://portret.ai/api'
import api from "@/api";

export default createStore({
  state: {
    status : 'wait_for_photos', //wait_for_photos, uploading ready, in_progress
    paid: false,
    email: '',
    prompts_limit: 0,
    prompts: 0,
    list_of_uploads : [],
    avatars:[],
    photos: [],
    page_index : 1,
    prompts_list : []
  },
  getters: {},
  mutations: {
    set_prompts_list(state:any, val:any){
      state.prompts_list = val
    },
    set_page(state:any, val:any){
      state.page_index = val
    },
    set_paid(state:any, val:any){
      state.paid = val
    },
    set_prompts(state:any,count:any){
      state.prompts = count
    },
    set_email(state:any,email: any){
      state.email = email
    },
    set_avatars(state:any, avatars:any){
      let list = avatars
      list.forEach((element:any) => {
        element.sim = Math.round(parseFloat(element.similarity)  * 100)
      });
      state.avatars = avatars
    },
    set_photos(state:any, photos:any){
      state.photos = photos
    },
    push_file(state:any, file){
      let pizda:any[] = Object.assign([], state.list_of_uploads)
      pizda.push(file)
      state.list_of_uploads = pizda
    },
    set_status(state, val:any){
      state.status = val
    },
    unshift_file(state:any,name){
      let pizda:any[] = Object.assign([], state.list_of_uploads.filter((el:any) => el != name))
      state.list_of_uploads = pizda
      if (pizda.length == 0){
        state.status = 'wait_for_photos'
      }
    }
  },
  actions: {
    proxy_file({commit, state}, file:any){

      let tus = (window as any).tus
      tus.canStoreURLs = false

      commit('push_file', file.name)
      commit('set_status', 'uploading')
      let UPLOAD_URL = baseurl + `/photos/uploads?name=${file.name}`

        let upload = new tus.Upload(file, {
                    endpoint: UPLOAD_URL,
                    retryDelays: [0, 1000, 3000, 5000],
                    canStoreURLs: false,
                    chunkSize: 1000000,
                    removeFingerprintOnSuccess: true,
                    onError: function(error: any) {
                      console.log('error')
                      alert("Please, reload the page and try another again")
                    },
                    onProgress: function(bytesUploaded: any, bytesTotal: any) {
                      let progress = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
                      console.log(progress);
                    },
                    onSuccess: function(data: any) {
                      console.log(data);
                      console.log('success');

                      api.add_photo(file.name).then(()=>{
                        commit('unshift_file', file.name)

                        if (state.list_of_uploads.length <= 1){
                          setTimeout(() => {
                            api.photos().then((data:any)=>{
                              commit('set_photos', data.data)
                            })
                          }, 5000);

                        }
                      })

                    }
                  });
                  upload.start();

    }
  },
  modules: {},
});
